import React, { useState, useEffect } from "react";
import { Box, Typography, Avatar, CardContent } from "@mui/material";

import { API_BASE_URL } from "../../../apiConfig";
import axios from "axios";
import LocalGroceryStoreIcon from "@mui/icons-material/LocalGroceryStore";
import LinkIcon from "@mui/icons-material/Link";
import { refreshTokenIfNeeded } from "../refreshTokenIfNeeded";
import { useNavigate } from "react-router-dom";

export default function StoreCard({ carId, onClose }) {
  const [storeData, setStoreData] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      setError(null);
      setIsLoading(true);

      try {
        const token = localStorage.getItem("token");

        if (!token) {
          throw new Error("Token not available. Please log in.");
        }

        const response = await axios.get(`${API_BASE_URL}Store/Find/${carId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setStoreData(response.data);
        setIsLoading(false);
      } catch (err) {
        if (err.response?.status === 401) {
          try {
            const newToken = await refreshTokenIfNeeded();

            if (!newToken) {
              navigate("/", { replace: true });
              return;
            }

            const response = await axios.get(
              `${API_BASE_URL}Store/Find/${carId}`,
              {
                headers: {
                  Authorization: `Bearer ${newToken}`,
                },
              },
            );

            setStoreData(response.data);
            setIsLoading(false);
          } catch (retryError) {
            setError("Failed to fetch store data");
            setIsLoading(false);
          }
        } else {
          setError("Failed to fetch store data");
          setIsLoading(false);
        }
      }
    };

    fetchData();
  }, [carId]);

  if (isLoading) {
    return <div>..جاري التحميل</div>;
  }
  return (
    <div
      dir="ltr"
      style={{
        width: "100%",
        boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
        borderRadius: "5px",
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
        <Avatar
          src={storeData?.storesImagePath || ""}
          sx={{ width: 300, height: 200 }}
          alt={storeData?.storeTitle || "N/A"}
        />
      </Box>
      <CardContent sx={{ textAlign: "right", mt: 2 }}>
        {error ? (
          <Typography color="error" sx={{ textAlign: "right" }}>
            {error}
          </Typography>
        ) : (
          <>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row-reverse",
                alignItems: "center",
                mb: 2,
              }}
            >
              <LocalGroceryStoreIcon sx={{ ml: 1, color: "blue" }} />
              <Typography variant="body1" dir="rtl">
                <strong>اسم المتجر:</strong> {storeData?.storeTitle || "N/A"}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row-reverse",
                alignItems: "center",
                mb: 2,
              }}
            >
              <LinkIcon sx={{ ml: 1, color: "blue" }} />
              <Typography variant="body1">
                {storeData?.slug || "N/A"} <strong>:اسم الرابط</strong>
              </Typography>
            </Box>
          </>
        )}
      </CardContent>
    </div>
  );
}
